var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsolationMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_59338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10982 17.4959C2.2205 16.9184 1.84211 16.3606 1.26468 16.2499C0.687247 16.1393 0.129426 16.5177 0.018752 17.0951C-0.0919218 17.6725 0.286462 18.2303 0.863896 18.341C1.44133 18.4517 1.99915 18.0733 2.10982 17.4959Z",
    fill: "url(#paint0_linear_507_59338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4564 17.5389C20.5914 16.9667 20.2371 16.3933 19.6648 16.2583C19.0926 16.1232 18.5192 16.4776 18.3842 17.0498C18.2491 17.6221 18.6035 18.1954 19.1757 18.3305C19.748 18.4655 20.3213 18.1111 20.4564 17.5389Z",
    fill: "url(#paint1_linear_507_59338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06445 1.17617V21.4043C1.06445 22.0541 1.59116 22.5805 2.24062 22.5805H18.2442C18.894 22.5805 19.4204 22.0538 19.4204 21.4043V4.98831L14.4321 0H2.24089C1.59116 0 1.06473 0.526704 1.06473 1.17617H1.06445Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6334 3.48383C15.8103 3.48383 15.9546 3.62782 15.9546 3.80502V16.539L4.5307 16.6223V3.80502C4.5307 3.62809 4.6747 3.48383 4.8519 3.48383H15.6337M15.6334 3.18359H4.8519C4.50866 3.18359 4.23047 3.46178 4.23047 3.80502V16.9244L16.2548 16.8368V3.80502C16.2548 3.46178 15.9766 3.18359 15.6334 3.18359Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9105 14.2344H4.5748C4.38463 14.2344 4.23047 14.3885 4.23047 14.5787V19.0507C4.23047 19.2408 4.38463 19.395 4.5748 19.395H15.9105C16.1007 19.395 16.2548 19.2408 16.2548 19.0507V14.5787C16.2548 14.3885 16.1007 14.2344 15.9105 14.2344Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40405 18.347L7.88714 17.4624L7.37024 18.347H6.57324L7.48864 16.7748L6.61707 15.2812H7.41406L7.88714 16.0916L8.36022 15.2812H9.15722L8.28564 16.7748L9.20104 18.347H8.40405Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3035 17.6725V18.347H9.50781V15.2812H10.2085V17.6725H11.3032H11.3035Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5479 17.6492L12.1521 17.2989C12.2616 17.5529 12.4499 17.7238 12.7959 17.7238C13.1418 17.7238 13.2121 17.5923 13.2121 17.4742C13.2121 17.2858 13.0368 17.2115 12.577 17.0844C12.1216 16.9573 11.675 16.7384 11.675 16.1516C11.675 15.5647 12.1742 15.2188 12.7042 15.2188C13.2341 15.2188 13.6019 15.4596 13.8253 15.9107L13.2341 16.2566C13.1291 16.0375 12.9845 15.902 12.7042 15.902C12.4853 15.902 12.3756 16.0114 12.3756 16.1342C12.3756 16.2743 12.4502 16.3707 12.9274 16.5152C13.3915 16.6554 13.9127 16.8174 13.9127 17.4655C13.9127 18.0567 13.4396 18.407 12.7741 18.407C12.1086 18.407 11.7185 18.1005 11.5479 17.6495V17.6492Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8074 5.85156H6.39648V7.06312H9.8074V5.85156Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2166 5.85156H10.8057V7.06312H14.2166V5.85156Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8074 8.25391H6.39648V9.46546H9.8074V8.25391Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2166 8.25391H10.8057V9.46546H14.2166V8.25391Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8074 10.6562H6.39648V11.8678H9.8074V10.6562Z",
    fill: "#00AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2166 10.6562H10.8057V11.8678H14.2166V10.6562Z",
    fill: "#00AD00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4316 0L19.4199 4.98831H15.5689C14.9409 4.98831 14.4316 4.4793 14.4316 3.85106V0Z",
    fill: "#DFEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4208 18.3614H1.06457C0.476619 18.3614 0 17.8848 0 17.2969V22.9357C0 23.5237 0.476619 24.0003 1.06457 24.0003H19.4205C20.0085 24.0003 20.4851 23.5237 20.4851 22.9357V17.2969C20.4851 17.8848 20.0085 18.3614 19.4205 18.3614H19.4208Z",
    fill: "url(#paint2_linear_507_59338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4501 21.175V19.5195H9.03463V21.175H7.9834L10.2424 23.0872L12.5016 21.175H11.4501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_59338",
    x1: 2.16876,
    y1: 17.2953,
    x2: -0.0292456,
    y2: 17.2953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_507_59338",
    x1: 18.2743,
    y1: 17.2952,
    x2: 20.4928,
    y2: 17.2952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_507_59338",
    x1: 10.2426,
    y1: 17.0848,
    x2: 10.2426,
    y2: 23.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_59338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4854,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationMode);
export default __webpack_public_path__ + "static/media/isolation-mode.8c51782b7c18bf64276290a99d7d1426.svg";
export { ForwardRef as ReactComponent };